export enum ImageType {
  master,
  square,
  none,
}

export interface FeaturedLink {
  imageUrl?: string
  imageType: ImageType
  title: string
  url: string
  shortDescription: string
}
